export default __webpack_public_path__ + "assets/front/scss/editorial.6999979dead180204e79a7e5109a4e0c.css";